import { initTelemetry, setDesktopVersion } from '@medcom/shared-ui/utils/telemetry.ts';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { AppRoot } from './App';
import { captureAisLinkToken } from './ais/aisLinkToken.ts';
import { oidcConfig } from './oidcConfig.ts';

captureAisLinkToken();

initTelemetry({
  url: window._env_.FARO_URL,
  apiKey: window._env_.FARO_API_KEY,
  appName: 'labrador-ui',
  version: window._runtime_.VERSION,
  environment: window._env_.ENV_TAG,
});

if (window.nativeApi) {
  window.nativeApi.version().then(setDesktopVersion);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  //strict mode breaks apollo polling (every component gets rendered twice)
  // see https://github.com/apollographql/apollo-client/issues/6634
  // <StrictMode>
  <AuthProvider {...oidcConfig}>
    <AppRoot />
  </AuthProvider>
  // </StrictMode>
);
